import { createContext } from "react";
import { IListContext } from "./../../types/IListContext";

export const ArchiveListContext = createContext<IListContext | undefined>(undefined);